import { html } from 'lit';
const Bubble =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M2.25 9A4.75 4.75 0 0 1 7 4.25h10A4.75 4.75 0 0 1 21.75 9v3.798a4.75 4.75 0 0 1-4.75 4.75h-5.873l-3.194 2.999A.75.75 0 0 1 6.67 20v-2.464a4.75 4.75 0 0 1-4.42-4.738zM7 5.75A3.25 3.25 0 0 0 3.75 9v3.798A3.25 3.25 0 0 0 7 16.048h.42a.75.75 0 0 1 .75.75v1.47l2.147-2.017a.75.75 0 0 1 .513-.203H17a3.25 3.25 0 0 0 3.25-3.25V9A3.25 3.25 0 0 0 17 5.75z" clip-rule="evenodd"/>
  </svg>
`;
export default Bubble;
